import React from 'react'
import PropTypes from 'prop-types'
import reactHtmlParser from 'react-html-parser'

const OpenEnded1 = (props) => {
  const { data } = props

  return (
    <>
      <div className="question-container">{reactHtmlParser(data.question)}</div>
      <input className="preview-input-text" name="open-ended-1" type="text" autoComplete="off" />
    </>
  )
}

OpenEnded1.propTypes = {
  data: PropTypes.object.isRequired,
}

export default OpenEnded1
